<template>
  <el-col :span="3" class="cc-btn-block">
    <el-button
      v-if="contacts"
      type="text"
      class="info"
      icon="el-icon-info"
      circle
      @click="$emit('info')"
    />
    <el-button type="text" class="call" @click="$emit('call')">
      <img src="@/assets/img/call-center-phone.png" />
    </el-button>
    <el-button
      type="danger"
      icon="el-icon-delete"
      circle
      @click="$emit('del')"
    />
  </el-col>
</template>

<script>
export default {
  name: 'ActionButtons',
  props: {
    contacts: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="sass">
.cc-btn-block
  display: flex
  align-items: center
  justify-content: center
  .el-button.is-circle.info
    padding: 0
    height: auto
    i
      font-size: 46px
      line-height: 1
  .call
    height: 40px
    padding: 0
    border: 0
    &:hover
      opacity: 0.7
    img
      width: 40px
      pointer-events: none
</style>
